/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionPartialUpdate
 */
export interface ProductionPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProductionPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionPartialUpdate
     */
    obscureName?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionPartialUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionPartialUpdate
     */
    longDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionPartialUpdate
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductionPartialUpdate
     */
    template?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionPartialUpdate
     */
    defaultGroup?: number | null;
}

export function ProductionPartialUpdateFromJSON(json: any): ProductionPartialUpdate {
    return ProductionPartialUpdateFromJSONTyped(json, false);
}

export function ProductionPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'obscureName': !exists(json, 'obscure_name') ? undefined : json['obscure_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'longDescription': !exists(json, 'long_description') ? undefined : json['long_description'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'template': !exists(json, 'template') ? undefined : json['template'],
        'defaultGroup': !exists(json, 'default_group') ? undefined : json['default_group'],
    };
}

export function ProductionPartialUpdateToJSON(value?: ProductionPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'obscure_name': value.obscureName,
        'description': value.description,
        'long_description': value.longDescription,
        'active': value.active,
        'template': value.template,
        'default_group': value.defaultGroup,
    };
}


